import { SortByType, getSortedContent } from '@/shared/helpers/sort';
import { useBreakpoints } from '@/shared/providers/Device';
import { MindStoryblok } from '@/shared/types/storyblok/storyblok-types';
import { useMemo, useState } from 'react';

export const sortContent = (content: MindStoryblok[], sortBy: SortByType) => {
    let sortedContent = [...content];
    if (sortedContent && sortBy) {
        if (sortBy === 'a_z') {
            sortedContent.sort((a: MindStoryblok, b: MindStoryblok) => {
                if (a.content?.fullname && b.content?.fullname) {
                    return a.content.fullname.localeCompare(b.content.fullname);
                }
                return 0;
            });
        } else if (sortBy === 'z_a') {
            sortedContent.sort((a: MindStoryblok, b: MindStoryblok) => {
                if (a.content?.fullname && b.content?.fullname) {
                    return b.content.fullname.localeCompare(a.content.fullname);
                }
                return 0;
            });
        } else {
            sortedContent = getSortedContent(sortedContent, sortBy, true);
        }
    }

    return sortedContent;
};

export const replaceNumber = (text: string, number: number): string => {
    return text.replace('{number}', String(number));
};

export const useItemsPerRow = () => {
    const { isXXSmall, isExtraSmall, isSmall, isMedium, isLarge, isExtraLarge } = useBreakpoints();

    return useMemo(() => {
        let items, margins;
        // Items
        if (isExtraLarge) items = 4;
        else if (isExtraSmall || isXXSmall) items = 1;
        else if (isSmall || isMedium) items = 2;
        else if (isLarge) items = 3;
        else items = 4;
        // Items margins
        if (isExtraLarge) margins = 18;
        else if (isLarge) margins = 16;
        else if (isSmall || isMedium) margins = 12;
        else margins = 18;

        return { items: items, margins: margins };
    }, [isXXSmall, isExtraSmall, isSmall, isMedium, isLarge, isExtraLarge]);
};

export const usePaginatedContent = (originalContent: MindStoryblok[], unity: number) => {
    const [shownCount, setShownCount] = useState(unity);
    const content = originalContent.slice(0, shownCount);

    const addMoreItems = () => {
        setShownCount(prevState => prevState + unity);
    };

    return [content, addMoreItems];
};
